import { Routes } from '@angular/router';

import { mpsRoutes } from './mps/routes/mps.routes';
import { applicationRoutes } from './app/application.routes';

export const globalRoutes: Routes = [
  ...applicationRoutes,
  ...mpsRoutes,
  // otherwise redirect to home
  {
    path: '**', redirectTo: '/price-list'
  }
];
